import React from "react";
import ErrorPage from "./ErrorPage.jsx";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    
    // Update state with error details
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // Render the error page when an error occurs
      return (
        <ErrorPage 
          error={this.state.error} 
          errorInfo={this.state.errorInfo} 
        />
      );
    }

    // Render children normally if no error
    return this.props.children;
  }
}

export default ErrorBoundary; 